import $ from "jquery";
import { createRoot } from "react-dom/client";
import { waitObject } from "@devowl-wp/react-utils";
import { createRecursiveUploadProBox, fixAddFileToSkipHiddenFiles, getNodeId } from "./uploaderHelpers.js";
import { applyUploadPermissionRules } from "../integrations/permissions.js";
import { __ } from "../utils/i18n.js";
import { rmlOpts } from "../utils/rmlOpts.js";
const MEDIA_NEW_UPLOADER_POLL_MS = 50;
const MEDIA_NEW_UPLOADER_MAX_TRIES = 400;
let mediaNewUploaderBound = false;
let mediaNewUploaderWait;
function getMediaNewUploader() {
    return window.uploader;
}
function bindMediaNewUploader(uploader) {
    if (mediaNewUploaderBound) {
        return;
    }
    mediaNewUploaderBound = true;
    fixAddFileToSkipHiddenFiles(uploader);
    uploader.bind("BeforeUpload", (...beforeUploadArgs)=>{
        const up = beforeUploadArgs[0];
        const file = beforeUploadArgs[1];
        const { multipart_params } = up.settings;
        let title;
        delete multipart_params.rmlCreateFolder;
        delete multipart_params.rmlFolder;
        const rmlFolderNode = getNodeId();
        if (rmlFolderNode && !isNaN(+rmlFolderNode.id)) {
            multipart_params.rmlFolder = rmlFolderNode.id;
            const div = document.createElement("div");
            ({ title } = rmlFolderNode);
            typeof title === "string" ? div.innerText = title : createRoot(div).render(title);
            title = div.innerText;
        }
        const source = file.getSource();
        const { relativePath } = source;
        if (relativePath?.split("/").length > 2) {
            if (process.env.PLUGIN_CTX === "pro") {
            /* Silence is golden... Until you have PRO Version! */ } else {
                createRecursiveUploadProBox();
            }
        }
        const mediaRowFilename = $(`#media-item-${file.id}`).find(".filename");
        if (mediaRowFilename.length > 0) {
            file.rmlFolderHTML = $("<div />").addClass("media-item-rml-folder").text(title).get(0).outerHTML;
            mediaRowFilename.after(file.rmlFolderHTML);
        }
    });
}
function scheduleMediaNewUploaderPatch() {
    const uploader = getMediaNewUploader();
    if (uploader) {
        bindMediaNewUploader(uploader);
        return;
    }
    if (mediaNewUploaderWait) {
        return;
    }
    mediaNewUploaderWait = waitObject(getMediaNewUploader, MEDIA_NEW_UPLOADER_POLL_MS, MEDIA_NEW_UPLOADER_MAX_TRIES).then((resolvedUploader)=>{
        if (resolvedUploader) {
            bindMediaNewUploader(resolvedUploader);
        }
    }).finally(()=>{
        mediaNewUploaderWait = undefined;
    });
}
function bootMediaNewPhp() {
    if (!$("body").hasClass("media-new-php")) {
        return;
    }
    if (window.prepareMediaItemInit) {
        const copyPrepareMediaItemInit = window.prepareMediaItemInit;
        window.prepareMediaItemInit = function(file, ...args) {
            copyPrepareMediaItemInit.apply(this, [
                file,
                ...args
            ]);
            const uploadFile = file;
            if (uploadFile.rmlFolderHTML) {
                const mediaRowFilename = $(`#media-item-${uploadFile.id}`).find(".filename");
                if (mediaRowFilename.length) {
                    mediaRowFilename.after(uploadFile.rmlFolderHTML);
                }
            }
        };
    }
    scheduleMediaNewUploaderPatch();
}
const GALLERY_ALLOWED_EXT = [
    "jpg",
    "jpeg",
    "jpe",
    "gif",
    "png"
];
function applyUploaderAddRules(preview, file, node, uploadStore) {
    applyUploadPermissionRules(preview, node, uploadStore);
    if (node.id === "all") {
        preview.node = uploadStore.getTreeItemById(+rmlOpts.others.rootId, false);
    }
    const { properties } = node;
    if (properties?.type) {
        const ext = file.name.substr(file.name.lastIndexOf(".") + 1).toLowerCase();
        const isCollection = +properties.type === 1;
        if ($.inArray(ext, GALLERY_ALLOWED_EXT) === -1 || isCollection) {
            preview.node = uploadStore.getTreeItemById(+rmlOpts.others.rootId, false);
            preview.deny = isCollection ? __("A collection cannot contain files. Upload moved to Unorganized...") : __("A gallery can only contain images. Upload moved to Unorganized...");
        }
    }
}
function applyUploaderTreeInit(state, props) {
    const rml_preselect = +state.initialSelectedId;
    if (!props.attachmentsBrowser && !isNaN(rml_preselect)) {
        const a = $('a.page-title-action[href*="/media-new.php"]');
        const href = a.attr("href");
        if (href) {
            const url = new URL(href, window.location.origin);
            url.searchParams.set("rml_preselect", String(rml_preselect));
            a.attr("href", url.toString());
        }
    }
}
export { applyUploaderAddRules, applyUploaderTreeInit, bootMediaNewPhp };
